// The "where does it hurt?" picker: the same body-area tiles as question one, so the
// first tap here IS the first answer. Shared by the /online-physical-therapy landing page
// and the /embed/picker iframe that WordPress pages load through loader.js.
import { BODY_AREAS } from '../lib/flow';
import { BodyIcon } from '../components/BodyIcon';
import { card } from '../components/ui';

export function AreaPicker({ onPick, narrow }: { onPick: (area: string) => void; narrow: boolean }) {
  return (
    <div style={{ ...card, padding: narrow ? 18 : 24, borderRadius: 16 }}>
      <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>Where does it hurt?</div>
      <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--slate)', marginBottom: 16 }}>Tap an area to start your plan.</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {BODY_AREAS.map((area) => (
          <button
            key={area}
            onClick={() => onPick(area)}
            style={{
              ...card,
              padding: narrow ? '10px 12px' : '12px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              textAlign: 'left',
              border: '1px solid var(--teal-tint)',
            }}
          >
            <BodyIcon area={area} style={{ width: 20, height: 40 }} />
            <span style={{ fontSize: 16, fontWeight: 700 }}>{area}</span>
          </button>
        ))}
      </div>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--teal-deep)', marginTop: 14, textAlign: 'center' }}>
        About 2 minutes. See your plan before you create an account.
      </div>
    </div>
  );
}
